import { resetOssClient } from "@/modules/global/services/oss";

const state = {
    loggedIn: false,
    scopes: [],
};

const mutations = {
    auth_authenticated(state, payload) {
        state.loggedIn = true;
        state.scopes = payload;
    },

    auth_destroyed(state) {
        state.loggedIn = false;
        state.scopes = [];

        // Kredensial OSS terikat pada identitas pemanggil. Semua jalur logout
        // bermuara ke mutation ini, jadi client lama dibuang di sini supaya
        // sesi berikutnya tidak memakai sisa kredensial sesi sebelumnya.
        resetOssClient();
    },
};

export default { state, mutations };



// WEBPACK FOOTER //
// ./src/modules/auth/stores/auth.js